module.exports = __webpack_public_path__ + "img/img-4_bka.6099dea6.png";